import { render, staticRenderFns } from "./item-list-leavejob.vue?vue&type=template&id=70529bb0&"
import script from "./item-list-leavejob.vue?vue&type=script&lang=js&"
export * from "./item-list-leavejob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports